

































































import Vue from 'vue';
import { Component, Prop, Ref } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

@Component<OtpChallenge>({})
export default class OtpChallenge extends Vue {
  @Prop({ type: String })
  email: string;

  code: string = null;

  @Ref('form')
  form: InstanceType<typeof ValidationObserver>;

  mounted() {
    if (!this.email) {
      this.$router.push('/forgot-password');
    }
  }

  async resendOtp(): Promise<void> {
    await this.$http.post('/authentication/staff/send-otp', {
      email: this.email,
    });
    await this.$cheeers.notify({
      lang: 'forgotPassword.sentNewOtp',
    });
  }

  async verifyOtp(): Promise<void> {
    const response = await this.$http.post('/authentication/staff/verify-otp', {
      email: this.email,
      code: this.code,
    });
    if (!response.data) {
      this.form.setErrors({
        otp: this.$t('forgotPassword.wrongOtp') as string,
      });
    } else {
      localStorage.setItem('token@forgot-password', response.data);
      localStorage.removeItem('email@forgot-password');
      this.$router.push('/forgot-password/change-password');
    }
  }
}
